import { Gradients } from './gradients';
import { Tracking } from './tracking';
export var tidy = Tracking.tidy;
export var keep = Tracking.keep;
export var dispose = Tracking.dispose;
export var time = Tracking.time;
export var grad = Gradients.grad;
export var valueAndGrad = Gradients.valueAndGrad;
export var grads = Gradients.grads;
export var valueAndGrads = Gradients.valueAndGrads;
export var variableGrads = Gradients.variableGrads;
export var customGrad = Gradients.customGrad;
//# sourceMappingURL=globals.js.map